<script>
import axios from "axios";
export default {
  data() {
    return {
      companyId : 0,
      activityLoader: false,
      result: [
        {
          month: "N.A",
        },
        {
          month: "N.A",
        },{
          month: "N.A",
        },
      ],
      productivity: [
        {
          activeHrs: 0,
          month: "N.A",
          change: 0,
          isIncreased: -1,
          prevActiveHrs: 0,
          series: [
            {
              name: "productivity",
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
      ],
      chartOptions: {
        chart: {
          height: 320,
          type: "line",
          toolbar: "false",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.2,
          },
        },
         xaxis: {
          categories: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30],
          tickAmount: 10  // optional tickAmount value
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#556ee6"],
        stroke: {
          curve: "smooth",
          width: 3,
        },
      },
    };
  },
  props: ['dataProp'],
  methods: {
    async getActivityData() {
      this.activityLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_ACTIVITY_URL + "/activity_report/dashboard_prod_data",
          { params: { companyId: this.companyId} }
        );
        if(response.data.success == "true") {
         if(response.data.data.length > 0) {
            this.result = response.data.data;
            for(var i = 0;i < this.result[1].series.length ;i++) {
              this.productivity[0].series[0].data[i] = this.result[1].series[i].productivity;
            }
            this.productivity[0].month = this.result[1].month;
            this.productivity[0].activeHrs = this.result[1].activeHrs;
            this.productivity[0].change = this.result[1].change;
            this.productivity[0].isIncreased = this.result[1].isIncreased;
            this.productivity[0].prevActiveHrs = this.result[1].prevActiveHrs;

            window.dispatchEvent(new Event("resize"));
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.activityLoader = false;
    },
    changeMonth(event) {
      this.activityLoader = true;
      try {
        switch (event.target.value) {
          case "0":
            for(var i = 0;i < this.result[0].series.length ;i++) {
              this.productivity[0].series[0].data[i] = this.result[0].series[i].productivity;
            }
            this.productivity[0].month = this.result[0].month;
            this.productivity[0].activeHrs = this.result[0].activeHrs;
            this.productivity[0].change = this.result[0].change;
            this.productivity[0].isIncreased = this.result[0].isIncreased;
            this.productivity[0].prevActiveHrs = this.result[0].prevActiveHrs;
            break;
          case "1":
            for(i = 0;i < this.result[1].series.length ;i++) {
              this.productivity[0].series[0].data[i] = this.result[1].series[i].productivity;
            }
            this.productivity[0].month = this.result[1].month;
            this.productivity[0].activeHrs = this.result[1].activeHrs;
            this.productivity[0].change = this.result[1].change;
            this.productivity[0].isIncreased = this.result[1].isIncreased;
            this.productivity[0].prevActiveHrs = this.result[1].prevActiveHrs;
            break;

          case "2":
            for(i = 0;i < this.result[2].series.length ;i++) {
              this.productivity[0].series[0].data[i] = this.result[2].series[i].productivity;
            }
            this.productivity[0].month = this.result[2].month;
            this.productivity[0].activeHrs = this.result[2].activeHrs;
            this.productivity[0].change = this.result[2].change;
            this.productivity[0].isIncreased = this.result[2].isIncreased;
            this.productivity[0].prevActiveHrs = this.result[2].prevActiveHrs;
            break;
        }
        window.dispatchEvent(new Event("resize"));
      } catch (error) {
        //console.log(error);
      }
       this.activityLoader = false;
    },
   
  },
  created() {
    this.companyId = this.dataProp;
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

  var today = new Date();

  for (var i = 0; i < 3; i++) {
   this.result[i].month = monthNames[(today.getMonth() - i)];
  }
  this.getActivityData();
  },
};
</script>

<template>

<div class="is-loading">
  <div class="preloader-component" v-show="activityLoader">
    <div class="status">
      <div class="spinner-chase">
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="clearfix">
        <div class="float-end">
          <div class="input-group input-group-sm">
            <select
              class="form-select form-select-sm"
              @change="changeMonth($event)"
            >
              <option value="0" >{{result[0].month}}</option>
              <option value="1" selected>{{result[1].month}}</option>
              <option value="2">{{result[2].month}}</option>
            </select>
            <label class="input-group-text">{{ $t('menuitems.dashboards.data.month') }}</label>
          </div>
        </div>
        <h4 class="card-title mb-4">{{ $t('menuitems.dashboards.data.productivity') }}</h4>
      </div>
     
      <div class="row" v-for="(data, index) of productivity" :key="index">
        <div class="col-lg-4">
          <div class="text-muted">
            <div class="mb-4">
              <p>{{ $t('menuitems.dashboards.data.thisMonth') }}</p>
              <h4>{{ data.activeHrs }} {{ $t('menuitems.dashboards.data.avgActiveHours') }}</h4>
              <div>
                <span v-if="data.isIncreased == 1" class="badge badge-soft-success font-size-12 me-1"
                  >+ {{ data.change }}%</span
                >
                <span v-if="data.isIncreased == 0 && data.prevActiveHrs != 0" class="badge badge-soft-danger font-size-12 me-1"
                  >- {{ data.change }}%</span
                >
                <span v-if="data.isIncreased == 0 && data.prevActiveHrs == 0" class="badge badge-soft-warning font-size-12 me-1"
                  >0 %</span
                >
                {{ $t('menuitems.dashboards.data.fromPreviousPeriod') }}
              </div>
            </div>

            <div class="mt-4">
              <p class="mb-2">{{ $t('menuitems.dashboards.data.previousMonth') }}</p>
              <h5>{{ data.prevActiveHrs }} {{ $t('menuitems.dashboards.data.avgActiveHours') }}</h5>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div id="line-chart"></div>
          <apexchart
            class="apex-charts"
            dir="ltr"
            height="300"
            :series="data.series"
            :options="chartOptions"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>